import { render } from "./newsShare.vue?vue&type=template&id=f8f07e06&scoped=true"
import script from "./newsShare.vue?vue&type=script&lang=js"
export * from "./newsShare.vue?vue&type=script&lang=js"

import "./newsShare.vue?vue&type=style&index=0&id=f8f07e06&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8f07e06"]])

export default __exports__